<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import {useStore} from "vuex";

export default {
  name: "MarksPage",
  components: {LoadingPage},
  setup() {

    let store = useStore()
    let loading = ref(false)
    let page = ref('worker')

    let marks = ref({
      adver_mark: [],
      worker_mark: [],
    })


    function get_marks() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show_mark'}, 'mark', true).then((res) => {
        loading.value = false
        marks.value = res.data
        marks.value.adver_mark.forEach((item) => {
          item.mark = true
        })
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_marks)
      })
    }

    get_marks()

    function seen_ads(item) {
      item.pics = []
      if (item.pic1 !== null) item.pics.push(item.pic1)
      if (item.pic2 !== null) item.pics.push(item.pic2)
      if (item.pic3 !== null) item.pics.push(item.pic3)
      if (item.pic4 !== null) item.pics.push(item.pic4)

      store.commit('set_advertising', item)
      router.push({name: 'DetailsAdvertising'})
    }

    store.commit('set_advertising', 'delete')

    return {
      page,
      loading,
      marks,
      seen_ads,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">نشان شده ها</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div class="position-sticky top-0 px-3 d-flex justify-content-between align-items-center mb-5">
        <p @click="page = 'ads'" :class="page === 'ads' ? 'bg_page':''"
           class="transition p-3 rounded-pill text-center font-bold font-5 shadow-custom w-48">آگهی های نشان شده</p>

        <p @click="page = 'worker'" :class="page === 'worker' ? 'bg_page':''"
           class="transition p-3 rounded-pill text-center font-bold font-5 shadow-custom w-48">خدمات رسان نشان شده</p>
      </div>

      <div v-if="page === 'worker'" class="">
        <div v-if="marks.worker_mark.length === 0"
             style="height: 60vh" class="animate__animated animate__fadeIn w-100 d-flex justify-content-center">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
            <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
          </div>
        </div>

        <div v-else v-for="item in marks.worker_mark" :key="item.id"
             class="animate__animated animate__fadeIn rounded-4 shadow-custom p-2 d-flex align-items-center justify-content-between mb-3">
          <div class="d-flex align-items-center">
            <img v-if="item.pic !== null" class="profile icon_border ms-2" :src="item.pic" alt="">
            <img v-else class="profile icon_border ms-2" src="../assets/img/defult-profile.svg" alt="">

            <div class="d-flex flex-column justify-content-between">
              <p class="font-6">تعمیر کار</p>
              <p class="font-4 text-color font-bold">{{ item.name }}</p>
              <p class="font-6">{{ item.state }} - {{ item.city }}</p>
            </div>
          </div>

          <div class="d-flex flex-column w-20">
            <div class="rounded-4 bg-custom d-flex align-items-center px-2 py-1 mb-2">
              <img class="icon-size-1 ms-2" src="../assets/img/icon-star.svg" alt="">
              <p class="font-5 text-color font-bold">{{ item.rate }}</p>
            </div>

            <router-link :to="{name:'DetailsWorker',params:{id:item.id}}" class="bg-green text-decoration-none text-color font-5 text-center rounded-4 font-bold px-2 py-1">جزئیات</router-link>
          </div>
        </div>
      </div>

      <div v-if="page === 'ads'" class="">
        <div v-if="marks.adver_mark.length === 0"
             style="height: 60vh" class="animate__animated animate__fadeIn w-100 d-flex justify-content-center">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
            <p class="font-4 text-center">در حال حاضر آیتمی وجود ندارد...!</p>
          </div>
        </div>

        <div v-else v-for="item in marks.adver_mark" :key="item.id" @click="seen_ads(item)"
             class="animate__animated animate__fadeIn bg-white shadow-custom p-2 d-flex justify-content-between rounded-4 mb-3">
          <div class="d-flex flex-column justify-content-around w-60">
            <div class="overflow-hidden">
              <p class="text-color font-bold font-4" :class="item.title.length >= 30 ? 'txtoverflow':''">{{ item.title }}</p>
            </div>

            <p v-if="item.price > 0" class="font-5">{{ item.price.toLocaleString() }} تومان</p>
            <p v-else class="font-5">توافقی</p>

            <p class="font-6">دقایقی پیش</p>

            <div class="hr-dash"></div>

            <p class="font-5">{{ item.state }} - {{ item.city }}</p>
          </div>

          <div class="img-ads rounded-4 animated-background">
            <img class="img-ads rounded-4" :src="item.pic1" alt="">
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<style scoped>
.img-ads {
  width: 10rem;
  height: 10rem;
}

.hr-dash {
  width: 100%;
  height: .1rem;
  border-bottom: .1rem dashed #0335BE;
}

.profile {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

.transition {
  transition: background-image 0.5s ease;
}


.bg_page {
  background-color: #0DDDB4; /* برای رنگ اولیه */
}

.bg_page::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(to left bottom, #0DDDB4, #053BC0);
  z-index: -1;
  transition: opacity 0.5s ease;
  opacity: 1;
}

.transition {
  position: relative;
  overflow: hidden;
  transition: background-color 0.5s ease;
}

.transition.bg_page::after {
  opacity: 1;
}

.transition:not(.bg_page)::after {
  opacity: 0;
}
</style>